const all_socials = {
  github_account: "https://github.com/tahakhan0",
  linkedIn_account: "https://www.linkedin.com/in/taha-abrar-khan/",
  twitter_account: "https://twitter.com/tahaaakhan",
};
export function getAllSocials() {
  return all_socials;
}
